<template>
    <div class="w-full h-full flex items-center justify-center px-5 lg:px-0">
        <div
            class="h-auto bg-white border border-gray-200 shadow-lg rounded-xl px-6 py-6 w-full lg:w-fit space-y-3 flex flex-col justify-center">
            <div class="w-full mt-3 flex flex-col justify-evenly space-y-3">
                <div class="text-center ">
                    <h1 class="text-xl font-bold text-primary">{{ $t('recover_password.resetPassword') }}</h1>
                </div>
                <div>


                    <label class="block text-sm font-medium text-gray-700 mb-1"
                        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                        {{ $t('recover_password.newPassword') }}
                    </label>
                    <input type="password" v-model="password" :class="[
                        'w-full border rounded-lg px-3 py-2 outline-none focus:ring-1 focus:ring-primary disabled:bg-gray-100 transition duration-200',
                        passwordError.error ? 'border-red-400' : 'border-gray-300'
                    ]" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" />
                    <p v-if="passwordError.error" class="text-red-500 text-xs mt-1"
                        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                        {{ passwordError.message }}
                    </p>

                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                        {{ $t('recover_password.confirmPassword') }}
                    </label>
                    <input type="password" v-model="passwordConfirmation" :class="[
                        'w-full border rounded-lg px-3 py-2 outline-none focus:ring-1 focus:ring-primary disabled:bg-gray-100 transition duration-200',
                        passwordConfirmationError.error ? 'border-red-400' : 'border-gray-300'
                    ]" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" />
                    <p v-if="passwordError.error" class="text-red-500 text-xs mt-1"
                        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                        {{ passwordConfirmationError.message }}
                    </p>
                </div>
                <!-- Button Submition -->
                <div>
                    <button @click="submitPassword"
                        class="w-full bg-primary text-white font-semibold py-2 px-4 rounded-lg hover:bg-primary-dark transition duration-200">
                        {{ $t('recover_password.submitNewPasword') }}
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>


<script setup>

import { ref, defineEmits } from 'vue';

import { resetPassword } from '@/api/admin';
import router from '@/router';
import { useAdminStore } from '@/stores/admin';

const emit = defineEmits(['toggleLoadingOn', 'toggleLoadingOff', 'toggleSuccessResetModal']);


const password = ref('');
const passwordConfirmation = ref('');

const passwordError = ref({
    error: false,
    message: ''
});

const passwordConfirmationError = ref({
    error: false,
    message: ''
});


const passwordReset = ref({
    error: true,
    message: ""
})

const validatePassword = () => {
    let hasError = false;

    passwordError.value.error = false;
    passwordError.value.message = '';
    passwordConfirmationError.value.error = false;
    passwordConfirmationError.value.message = '';

    if (password.value.length < 8) {
        passwordError.value.error = true;
        passwordError.value.message = 'Le mot de passe doit contenir au moins 8 caractères.';
        hasError = true;
    }

    if (passwordConfirmation.value !== password.value) {
        passwordConfirmationError.value.error = true;
        passwordConfirmationError.value.message = 'Les mots de passe ne correspondent pas.';
        hasError = true;
    }

    return hasError;
};



const adminStore = useAdminStore();


const submitPassword = async () => {
    emit('toggleLoadingOn');
    if (validatePassword()) {
        emit('toggleLoadingOff');

        return;
    }
    // Call the API to reset the password
    const payload = {
        password: password.value,
        password_confirmation: passwordConfirmation.value
    };

    try {
        let response =await resetPassword(payload);

        console.log('response :>> ', response);

        if (response.data.success) {
            localStorage.removeItem('auth_token');
            adminStore.$reset();
            emit('toggleSuccessResetModal');

            router.push('/admin');
        } else {
            //show modal of error
            passwordReset.value.error = true;
            passwordReset.value.message = response.data.message || 'Une erreur s\'est produite lors de la réinitialisation du mot de passe.';
            console.error('Error resetting password:', response.data.message);

            emit('toggleLoadingOff');

        }

    } catch (error) {
      

        passwordReset.value.error = true;
        passwordReset.value.message =  'Une erreur s\'est produite lors de la réinitialisation du mot de passe.';
        //show message of error

    }
    emit('toggleLoadingOff');

}


</script>